<div class="modal-overlay" (click)="onCancel()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header-row">
      <div class="modal-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0D1121" stroke-width="2">
          <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
        </svg>
      </div>
      <div>
        <h2 class="modal-title">Create Document Batch</h2>
        <p class="modal-subtitle">Define a batch to organize and analyze enterprise documents together.</p>
      </div>
    </div>

    <app-text-input
      label="Batch Name"
      labelStyle="normal"
      placeholder="e.g; financial reports"
      [value]="batchName()"
      (valueChange)="batchName.set($event)"
    ></app-text-input>

    <app-text-input
      label="Description"
      labelStyle="normal"
      type="textarea"
      placeholder="Describe..."
      [value]="description()"
      (valueChange)="description.set($event)"
      [maxLength]="maxDescriptionLength"
      [rows]="4"
    ></app-text-input>

    <div class="modal-actions">
      <app-button variant="secondary" [disabled]="isSaving" (clicked)="onCancel()">Cancel</app-button>
      <app-button variant="primary" [disabled]="!batchName().trim() || isSaving" (clicked)="onSave()">
        {{ isSaving ? 'Creating...' : 'Save' }}
      </app-button>
    </div>
  </div>
</div>